import { IState } from './VehicleSearch.reducer';

export interface IActions {
  [VehicleActionTypes.setVehicleId]?: IState['VehicleId'];
  [VehicleActionTypes.setCatalogueTypeId]?: IState['CatalogueTypeId'];
  [VehicleActionTypes.setCatalogueTypes]?: IState['CatalogueTypes'];
  [VehicleActionTypes.setSelectedCatalogueEntry]?: IState['SelectedCatalogueEntry'];
  [VehicleActionTypes.setSearched]?: IState['Searched'];
}

export enum VehicleActionTypes {
  setVehicleId = 'setVehicleId',
  setCatalogueTypeId = 'setCatalogueTypeId',
  setCatalogueTypes = 'setCatalogueTypes',
  setSelectedCatalogueEntry = 'setSelectedCatalogueEntry',
  setSearched = 'setSearched',
}
